// extracted by mini-css-extract-plugin
module.exports = {"button":"ActiveSectionsData_button__W0o4d","column":"ActiveSectionsData_column__D0rz1"};